<template>
  <ul class="wrapper" style="margin-left: 30px">
    <li class="item" :key="index" v-for="(item, index) in router">
      <div v-if="!item.childList.length > 0">
        <Icon
          v-show="!item.childList.length == 0"
          :type="item.showHide ? 'ios-arrow-up' : 'ios-arrow-down'"
          style="font-size: 16px"
          @click="item.showHide = !item.showHide"
        />
        <Checkbox v-model="item.enabled" @on-change="first(item)">
          {{ item.name }}
          <Tag :color="item.type == 1 ? 'blue' : 'red'">{{
            item.type == 1 ? "菜单" : "功能"
          }}</Tag>
        </Checkbox>
      </div>

      <template v-else>
        <Icon
          :type="item.showHide ? 'ios-arrow-up' : 'ios-arrow-down'"
          style="font-size: 16px"
          @click="item.showHide = !item.showHide"
        />
        <Checkbox v-model="item.enabled" @on-change="first(item)">
          {{ item.name }}
          <Tag :color="item.type == 1 ? 'blue' : 'red'">{{
            item.type == 1 ? "菜单" : "功能"
          }}</Tag>
        </Checkbox>
        <my-menu :router="item.childList" v-if="item.showHide"></my-menu>
      </template>
    </li>
  </ul>
</template>
<script>
export default {
  name: "myMenu",
  props: ["router"], // Menu 组件接受一个 router 作为菜单数据

  data() {
    return {
      toggleShow: false, // toggle 状态
    };
  },
  methods: {
    handleToggleShow() {
      // 处理 toggle 状态的是否展开子菜单 handler
      this.toggleShow = !this.toggleShow;
    },
    first(row) {
      function ddd(datas) {
        for (const i in datas.childList) {
          datas.childList[i].enabled = datas.enabled;
          if (datas.childList[i].childList.length > 0) {
            ddd(datas.childList[i]);
          }
        }
      }
      ddd(row);
    },
  },
};
</script>
<style>
.item-title {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/authorityMenu.vue